(function () {
  var SELECTOR = '.cd-quality-materials';
  var HEADER_SELECTOR = '[data-site-header]';
  var DESKTOP_BREAKPOINT = 1024;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function easeInOutCubic(t) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function getViewportSize() {
    var vv = window.visualViewport;
    return {
      width: vv && vv.width ? vv.width : window.innerWidth,
      height: vv && vv.height ? vv.height : window.innerHeight,
    };
  }

  function setHeaderTheme(isLight) {
    var header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;

    if (isLight) {
      header.setAttribute('data-header-theme', 'light');
      header.classList.add('is-light');
    } else {
      header.setAttribute('data-header-theme', 'dark');
      header.classList.remove('is-light');
    }
  }

  function getDesktopScale(media) {
    var viewport = getViewportSize();
    var viewportWidth = viewport.width;
    var viewportHeight = viewport.height;
    var baseWidth = media.offsetWidth || 1;
    var baseHeight = media.offsetHeight || 1;
    var rect = media.getBoundingClientRect();
    var centerX = rect.left + rect.width / 2;
    var centerY = rect.top + rect.height / 2;
    var requiredWidth = Math.max(centerX, viewportWidth - centerX) * 2;
    var requiredHeight = Math.max(centerY, viewportHeight - centerY) * 2;

    return Math.max(requiredWidth / baseWidth, requiredHeight / baseHeight, 1);
  }

  function buildLineflow(section) {
    section.querySelectorAll('[data-cd-qm-lineflow]').forEach(function (node) {
      if (node.getAttribute('data-cd-qm-lineflow-ready') === 'true') return;

      var label = (node.textContent || '').replace(/\s+/g, ' ').trim();
      node.setAttribute('data-cd-qm-lineflow-ready', 'true');
      node.setAttribute('aria-label', label);
      node.classList.add('cd-quality-materials__lineflow');

      var inner = document.createElement('span');
      inner.className = 'cd-quality-materials__lineflow-text';
      inner.setAttribute('aria-hidden', 'true');
      inner.textContent = label;

      node.textContent = '';
      node.appendChild(inner);
    });
  }

  function prepareTextReveal(section) {
    var lines = Array.prototype.slice.call(
      section.querySelectorAll('[data-cd-qm-lineflow]')
    );

    lines.forEach(function (node) {
      var delay = 0;

      if (node.classList.contains('cd-quality-materials__copy-mobile')) {
        delay = node.closest('.cd-quality-materials__copy--bottom') ? 160 : 0;
      } else {
        delay = node.closest('.cd-quality-materials__copy--bottom') ? 140 : 0;
      }

      node.style.setProperty('--cd-qm-line-delay', delay + 'ms');
    });
  }

  function revealText(section) {
    if (section.__cdQualityMaterialsTextVisible) return;
    section.__cdQualityMaterialsTextVisible = true;
    section.classList.add('cd-quality-materials--text-visible');
  }

  function setLineState(node, progress, fade) {
    if (!node) return;
    var section = node.closest(SELECTOR);
    if (section && section.__cdQualityMaterialsTextVisible) return;

    var line = node.querySelector('.cd-quality-materials__lineflow-text');
    if (!line) return;

    var local = easeInOutCubic(clamp(progress, 0, 1));
    var opacity = clamp(local * fade, 0, 1);
    var y = (1 - local) * 1.06;

    line.style.setProperty('--cd-qm-line-opacity', opacity.toFixed(4));
    line.style.setProperty('--cd-qm-line-y', y.toFixed(4) + 'em');
  }

  function setupSection(section) {
    if (!section || section.__cdQualityMaterialsReady) return;
    section.__cdQualityMaterialsReady = true;

    buildLineflow(section);
    prepareTextReveal(section);

    var media = section.querySelector('.cd-quality-materials__media');
    var track = section.querySelector('.cd-quality-materials__track');
    var sticky = section.querySelector('.cd-quality-materials__sticky');
    var lines = Array.prototype.slice.call(
      section.querySelectorAll('[data-cd-qm-lineflow]')
    );

    if (!media || !track || !sticky) return;

    var rafId = null;
    var lastWidth = window.innerWidth;
    var lastHeaderState = null;

    function applyState() {
      rafId = null;

      var viewport = getViewportSize();
      var viewportHeight = viewport.height;
      var isMobile = window.innerWidth <= DESKTOP_BREAKPOINT;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var trackRect = track.getBoundingClientRect();
      var stickyHeight = sticky.offsetHeight || viewportHeight;
      var totalScrollable = Math.max(track.offsetHeight - stickyHeight, 1);
      var rawProgress = clamp(-trackRect.top / totalScrollable, 0, 1);
      var eased = 1 - Math.pow(1 - rawProgress, 3);
      var entryProgress = clamp(
        (viewportHeight - trackRect.top) / Math.max(viewportHeight * 0.78, 1),
        0,
        1
      );
      var introBase = easeInOutCubic(entryProgress);
      var fade = clamp(1 - Math.max(rawProgress - 0.18, 0) * 1.6, 0, 1);
      var mediaIntro = easeInOutCubic(clamp((entryProgress - 0.05) / 0.46, 0, 1));

      if (entryProgress >= 0.18 || rawProgress > 0.01) {
        revealText(section);
      }

      if (reduced) {
        revealText(section);
        section.style.setProperty('--cd-qm-progress', '1');
        section.style.setProperty('--cd-qm-progress-eased', '1');
        section.style.setProperty('--cd-qm-scale', isMobile ? '1' : String(getDesktopScale(media)));
        section.style.setProperty('--cd-qm-copy-opacity', '0');
        section.style.setProperty('--cd-qm-copy-shift', isMobile ? '0px' : '180px');
        section.style.setProperty('--cd-qm-media-radius', '0px');
        section.style.setProperty('--cd-qm-media-opacity', '1');
        section.style.setProperty('--cd-qm-media-y', '0px');
        section.style.setProperty('--cd-qm-image-scale', '1');
        lines.forEach(function (node) {
          setLineState(node, 1, 1);
        });
        if (lastHeaderState !== 'dark') {
          setHeaderTheme(false);
          lastHeaderState = 'dark';
        }
        return;
      }

      if (isMobile) {
        section.style.setProperty('--cd-qm-progress', rawProgress.toFixed(4));
        section.style.setProperty('--cd-qm-progress-eased', eased.toFixed(4));
        section.style.setProperty('--cd-qm-scale', '1');
        section.style.setProperty('--cd-qm-copy-opacity', clamp(1 - rawProgress * 2.25, 0, 1).toFixed(4));
        section.style.setProperty('--cd-qm-copy-shift', '0px');
        section.style.setProperty('--cd-qm-media-radius', '0px');
        section.style.setProperty('--cd-qm-media-opacity', clamp(mediaIntro, 0, 1).toFixed(4));
        section.style.setProperty('--cd-qm-media-y', ((1 - mediaIntro) * 28).toFixed(2) + 'px');
        section.style.setProperty('--cd-qm-image-scale', (1.08 - mediaIntro * 0.08).toFixed(4));

        setLineState(lines[0], introBase / 0.42, fade);
        setLineState(lines[1], introBase / 0.42, fade);
        setLineState(lines[2], (introBase - 0.14) / 0.40, fade);
        setLineState(lines[3], (introBase - 0.14) / 0.40, fade);

        var mobileLight = rawProgress >= 0.82;
        if (mobileLight !== (lastHeaderState === 'light')) {
          setHeaderTheme(mobileLight);
          lastHeaderState = mobileLight ? 'light' : 'dark';
        }
        return;
      }

      var coverScale = getDesktopScale(media);
      var scale = 1 + (coverScale - 1) * eased;
      var copyOpacity = clamp(1 - rawProgress * 2.45, 0, 1);
      var copyShift = 180 * eased + 'px';
      var radius = 24 * (1 - eased) + 'px';

      section.style.setProperty('--cd-qm-progress', rawProgress.toFixed(4));
      section.style.setProperty('--cd-qm-progress-eased', eased.toFixed(4));
      section.style.setProperty('--cd-qm-scale', scale.toFixed(4));
      section.style.setProperty('--cd-qm-copy-opacity', copyOpacity.toFixed(4));
      section.style.setProperty('--cd-qm-copy-shift', copyShift);
      section.style.setProperty('--cd-qm-media-radius', radius);
      section.style.setProperty('--cd-qm-media-opacity', clamp(mediaIntro, 0, 1).toFixed(4));
      section.style.setProperty('--cd-qm-media-y', ((1 - mediaIntro) * 24).toFixed(2) + 'px');
      section.style.setProperty('--cd-qm-image-scale', (1.06 - mediaIntro * 0.06).toFixed(4));

      setLineState(lines[0], introBase / 0.42, fade);
      setLineState(lines[1], 1, 0);
      setLineState(lines[2], (introBase - 0.14) / 0.40, fade);
      setLineState(lines[3], 1, 0);

      var desktopLight = rawProgress >= 0.82;
      if (desktopLight !== (lastHeaderState === 'light')) {
        setHeaderTheme(desktopLight);
        lastHeaderState = desktopLight ? 'light' : 'dark';
      }
    }

    function requestApplyState() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(applyState);
    }

    requestApplyState();

    window.addEventListener('scroll', requestApplyState, { passive: true });
    window.addEventListener('resize', function () {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
      }
      requestApplyState();
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', requestApplyState);
      window.visualViewport.addEventListener('scroll', requestApplyState);
    }
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
